<button
  [type]="type()"
  [disabled]="disabled()"
  [attr.aria-label]="ariaLabel()"
  [attr.id]="buttonId()"
  [class]="rootClasses()"
>
  <i class="pi {{ icon() }} text-[14px]" aria-hidden="true"></i>
</button>
